import { Component } from "react"
import { CardsContent } from "../components/cards/CardsContent"
import { CardsInfoContent } from "../components/cards/CardsInfoContent"
import { Footer } from "../components/Footer"
import { Header } from "../components/Header"

export class CardsPage extends Component {
  render = () => (
    <>
      <div className="main__bg">
        <video autoPlay loop muted playsInline poster="img/bg.jpg" className="fullscreen-bg__video">
          <source src="/img/video_bg.mp4" type="video/mp4" />
        </video>
        <div className="main-box">
          <Header />
          <CardsInfoContent />
        </div>
      </div>

      <CardsContent />

      <Footer isDark={true} />
    </>
  )
}
